import { Box } from '@mui/material';
import { BoxProps } from '@mui/material/Box/Box';
import { useTheme } from '@mui/styles';

export const OrgUnitSectionWrapper = (props: BoxProps) => {
  const { children, sx, ...boxProps } = props;

  const theme = useTheme();

  return (
    <Box
      {...boxProps}
      sx={{
        padding: theme.spacing(1),
        margin: theme.spacing(-1),
        borderRadius: theme.spacing(1.5),
        backgroundColor: '#fafafa',
        '& .MuiInputBase-root': {
          backgroundColor: theme.palette.background.default,
        },
      }}
    >
      {children}
    </Box>
  );
};
